import { render, staticRenderFns } from "./MeasurementTypeSelect.vue?vue&type=template&id=6e52da9a&scoped=true&"
import script from "./MeasurementTypeSelect.vue?vue&type=script&lang=js&"
export * from "./MeasurementTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e52da9a",
  null
  
)

export default component.exports